<template>
  <div class="leaderboard" :ready="isReady">
    <Background :pump="null" :time="'night'"></Background>
    <div class="content">
        <div class="header">
          <div class="header-container">
            <div class="title"><b>Scada SuperHero</b> Leaderboard</div>
            <div class="buttons"><button @click="exit()" class="action-button action-backresults">Back to Menu</button></div>
          </div>
        </div>
        <div>
            <div class="leader-header">
              <div class="col-start"></div>
              <div class="col-pos">Pos</div>
              <div class="col-player">Player Name</div>
              <div class="col-challenge">Challenge 1</div>
              <div class="col-challenge">Challenge 2</div>
              <div class="col-challenge">Challenge 3</div>
              <div class="col-total">Total Score</div>
            </div>
            <div class="leader-item" v-for="item in leaderboardData" :key="item.position"
              :position="item.position" :empty="item.name==null" :current="item.name==$store.state.userData.name && item.company==$store.state.userData.companyName">
              <div class="item-container">
                <div class="col-start">
                  <div v-if="item.position<4" class="cup">
                    <img v-if="item.position==1 || item.position==3" src="@/assets/img/cup.svg" width="40">
                    <img v-if="item.position==2" src="@/assets/img/cup-white.svg" width="35">
                  </div>
                </div>
                <div class="col-pos">{{item.position}}</div>
                <div class="col-player">
                  <div>
                    <small>Your Top Score</small>
                    <div>{{item.name || 'No Top Score'}} <span class="company">{{item.company}}</span></div>
                  </div>
                </div>
                <div class="col-challenge">{{formatNumber(item.challenge1)}}</div>
                <div class="col-challenge">{{formatNumber(item.challenge2)}}</div>
                <div class="col-challenge">{{formatNumber(item.challenge3)}}</div>
                <div class="col-total">{{formatNumber(item.score)}}</div>
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

import Background from '@/components/Background.vue'

export default {
  name: 'leaderboard',
  data: function () {
    return {
      leaderboardData: [],
      isReady: false
    }
  },
  components: {
    Background
  },
  mounted: function () {
    const self = this
    const history = JSON.parse(JSON.stringify(this.$store.state.userHistory))
    const sortedHistory = history.sort((a, b) => {
      return b.totalScore - a.totalScore
    })
    for (const idx in sortedHistory) {
      if (this.leaderboardData.length < 10) {
        const hist = sortedHistory[idx]
        this.leaderboardData.push({
          position: idx * 1 + 1,
          name: hist.name,
          company: hist.companyName,
          challenge1: hist.maxScores[1],
          challenge2: hist.maxScores[2],
          challenge3: hist.maxScores[3],
          score: hist.totalScore
        })
      }
    }
    for (let i = this.leaderboardData.length; i < 10; i++) {
      this.leaderboardData.push({
        position: i + 1,
        name: null,
        company: '',
        score: 0
      })
    }
    setTimeout(function () {
      self.isReady = true
    }, 100)
  },
  methods: {
    exit: function () {
      this.$router.push('/')
    },
    formatNumber: function (num) {
      if (typeof num === 'undefined' || num === 0) {
        return '-'
      }
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss" >
.leaderboard{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.background::v-deep{
  .day{
    display: none;
  }
  .night{
    filter: brightness(0.5) blur(2px);
    opacity: 0.5;
  }
}
.content{
    z-index: 1;
    width: 100%;
    height: 100vh;
    color: #FFFFFF;
    .header{
      width: 100%;
      border-bottom: 1px solid #ffffff80;
      .header-container{
        display: flex;
        max-width: 1440px;
        margin: 0 auto;
        padding-left: 40px;
        justify-content: space-between;
        align-items:center;
      }
      .title{
          font-size: 50px;
          line-height: 2.5em;
      }
    }
    .leader-header, .leader-item{
        margin: 0 auto;
        max-width: 1440px;
        padding-left: 50px;
    }
    .leader-header, .leader-item > .item-container{
        display: flex;
        justify-content: space-between;
    }
    .col-player {
        flex: 1;
        padding-left: 2vw;
        text-align: left;
    }
    .col-pos{
        flex-basis: 90px;
    }
    .col-challenge{
        flex-basis: 11vw;
    }
    .col-total{
        flex-basis: 11vw;
    }
    .leader-header{
        margin-top: 2vh;
        line-height: 3em;
        text-transform: uppercase;
        font-weight: bold;
        .col-total{
          position: relative;
          margin-right: 8px;
          &::before, &::after{
            display: inline-block;
            content: ' ';
            width: 1vw;
            height: 1px;
            border-bottom: 1px solid #FFFFFF33;
            position: absolute;
            top: 50%;
          }
          &::before{
            left: 0;
          }
          &::after{
            right: 0;
          }
        }
    }
    .leader-item{
        opacity: 0;
        top: 100vh;
        transition: opacity linear 0.8s, top ease-in 0.5s;
        line-height: 6vh;
        border-radius: 3vh;
        border: 0.5vh solid transparent;
        text-transform: normal;
        font-size: 20px;
        position:relative;
        box-sizing: border-box;
        .item-container > div{
          border-top: 2px solid #FFFFFF33;
          border-bottom: 2px solid #FFFFFF33;
        }
        .col-start{
          border: 0px;
          .cup{
            width: 6.4vh;
            height: 6.4vh;
            position: absolute;
            z-index: 1;
            left: -2px;
            top: 0px;
            background-color: #272727;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            border: 4px solid #161616;
          }
        }
        .col-pos{
          background-color: #141414;
          border-radius: 3.2vh 0 0 3.2vh;
          border-color: #141414;
          font-weight: bold;
          font-size: 32px;
          text-align: right;
          padding-right: 32px;
        }
        .col-player{
          background-color: #FFFFFF1A;
          overflow: hidden;
          white-space: nowrap;
          small{
            position: absolute;
            top: -0.6vh;
            font-size: 16px;
            font-weight: bold;
            text-transform: uppercase;
            color: #F1C40F;
            display: none;
          }
        }
        .col-challenge{
          background-color: #FFFFFF1A;
        }
        .col-total{
          border-radius: 0 1.4vh 1.4vh 0;
          background-color: #FFFFFF;
          font-size: 32px;
          font-weight: bold;
          color: #282622;
        }
        .col-player{
          font-size: 28px;
          span{
            font-size: 16px;
            color: #00B5E2;
            font-weight: bold;
            font-style: italic;
          }
        }
    }
    .leader-item[current='true']{
      > div{
        opacity: 0;
        transition: opacity linear 1s;
        transition-delay: 0.5s;
      }
      .col-player {
        small{
          display: block;
        }
        div{
          margin-top: 0.9vh;
          margin-bottom: -0.9vh;
        }
      }
      .item-container{
        border: 4px solid #ffffff80;
        border-radius: 3.9vh 2.1vh 2.1vh 3.9vh;
        overflow: hidden;
      }
    }
    .leader-item[position='1']{
      padding-left: 0;
      border: 8px solid #F1C40F80;
      box-sizing: border-box;
      border-radius: 3.9vh 2vh 2vh 3.9vh;
      .item-container{
        border: 0px;
        overflow: initial;
      }
      .col-pos{
        flex-basis: 140px;
        background-color: #F1C40F;
        color: #282622;
        border-color: #F1C40F;
        padding-right:35px;
      }
      .col-start{
        .cup{
          left: -12px;
          top: -2px;
          width: 7.2vh;
          height: 7.2vh;
        }
      }
      .col-total{
        border-radius: 0 1.4vh 1.4vh 0;
        border-color: #F1C40F;
        background-color: #F1C40F;
        border-top: 4px solid #F1C40F;
        border-bottom: 4px solid #F1C40F;
        border-right: 4px solid #F1C40F;
        color: #FFFFFF;
      }
      .col-challenge{
        border-color: #F1C40F;
        border-width: 4px;
      }
      .col-player{
        border-color: #F1C40F;
        border-width: 4px;
      }
    }
    .leader-item[position='2']{
      .col-pos{
        background-color: #FFFFFF;
        color: #282622;
        border-color: #FFFFFF;
      }
    }
    .leader-item[position='3']{
      .col-pos{
        background-color: #F1C40F;
        color: #282622;
        border-color: #F1C40F;
      }
    }
    .leader-item[position='10']{
      .col-pos{
        padding-right: 24px;
      }
    }
    .leader-item[empty='true']{
      .col-player{
        color: #FFFFFF80;
      }
      .col-total{
        background-color: #FFFFFF80;
      }
    }
}
.leaderboard[ready='true']{
  .leader-item{
    opacity: 1;
    top: 0;
    > div{
      opacity: 1;
    }
  }
}

@media (max-width: 1500px){
  .content .header .header-container, .content .leader-header, .content .leader-item{
    max-width: 90%;
  }
  .content .leader-item .col-player{
    font-size: 24px;
  }
  .content .leader-item .col-challenge{
    font-size: 22px;
  }
  .content .leader-item .col-total{
    font-size: 24px;
  }
  .leader-header > div{
    font-size: 14px;
  }
}
@media (max-height: 1040px){
  .content .header .title{
    font-size: 40px;
  }
  .content .leader-item .col-player{
    font-size: 24px;
  }
  .content .leader-item .col-total{
    font-size: 24px;
  }
  .content .leader-item .col-challenge{
    font-size: 22px;
  }
  .content .leader-item .col-start .cup img{
    width: 60%;
  }
}
@media (max-height: 940px){
  .content .header .title{
    font-size: 32px;
  }
  .content .leader-item .col-player{
    font-size: 20px;
  }
  .content .leader-item .col-total{
    font-size: 20px;
  }
  .content .leader-item .col-challenge{
    font-size: 18px;
  }
}
@media (max-height: 790px){
  .content .header .title{
    font-size: 28px;
  }
  .leader-header .col-total{
    font-size: 14px;
  }
  .content .leader-item .col-player{
    font-size: 18px;
  }
  .content .leader-item .col-total{
    font-size: 18px;
  }
  .content .leader-item .col-player small{
    font-size: 14px;
  }
  .content .leader-item[position="1"]{
    border-radius: 3.9vh 2.5vh 2.5vh 3.9vh;
  }
}
@media (max-height: 730px){
  .content .header .title{
    font-size: 24px;
  }
  .content .leader-item .col-player{
    font-size: 16px;
  }
  .content .leader-item .col-total{
    font-size: 16px;
  }
  .content .leader-item .col-player small{
    font-size: 12px;
  }
}
</style>
